var setupFee = {
  setupFeeId: setupFeeProductId,
  setupFeeThreshold: 50,
  removeFromCart: function() {
    var self = this;
    $.ajax({
      url: '/cart/change.js',
      type: 'post', 
      dataType: 'json', 
      data: {
      quantity: 0,
      id: self.setupFeeId
    }
    }).done(function(response) {
      window.location.reload();
    }).fail(function(error) {
      console.log(error);
    });
  },
  addToCart: function() {
    var self = this;
    $.ajax({
      url: '/cart/add.js',
      type: 'post', 
      dataType: 'json', 
      data: {
        quantity: 1,
        id: self.setupFeeId,
        properties: {
          'Reason': 'Products in cart amount to a total less than $' + self.setupFeeThreshold + ' (setup fee not included).'
        }
      }
    }).done(function(response) {
      window.location.reload();
    }).fail(function(error) {
      console.log(error);
    });
  },
  checkCart: function() {
    var self = this;
    $.ajax({
      url: '/cart.js',
      type: 'get',
      dataType: 'json',
    }).done(function(response) {
      var total = (response.total_price / 100).toFixed(2);
      var threshold = self.setupFeeThreshold !== 0 ? self.setupFeeThreshold - 0.01 : self.setupFeeThreshold;
      if(response.items.length) {
        var setupFeeProduct = response.items.filter(function(item) {
          return item.id == self.setupFeeId;
        });
        var printShopProducts = response.items.filter(function(item) {
          return item.vendor == 'Print Shop by Vantage' && item.id != self.setupFeeId;
        });
        var printShopTotal = response.items.reduce(function(itemA, itemB) {
          if(itemB.vendor == 'Print Shop by Vantage' && itemB.id != self.setupFeeId) {
            return itemA + itemB['final_line_price'];
          } else {
            return itemA;
          }
        }, 0);
        var printShopTotalFormatted = (printShopTotal / 100).toFixed(2);
        if(setupFeeProduct.length) {
          var price = ($('[data-variant-id="' + self.setupFeeId + '"]').data('variant-price') / 100).toFixed(2);
          printShopTotalFormatted -= price;
        }
        if(printShopTotalFormatted <= threshold && !setupFeeProduct.length && printShopProducts.length) {
          self.addToCart();
        } else if(printShopTotalFormatted > threshold && setupFeeProduct.length) {
          self.removeFromCart();
        }
        if((response.items.length == 1 && response.items[0].id == self.setupFeeId) || (setupFeeProduct.length && !printShopProducts.length)) {
          self.removeFromCart();
        }
      }
    }).fail(function(error) {
      console.log(error);
    });
  },
  init: function() {
    var self = this;
    $('.quantity a').on('click', function() {
      $(document).one('ajaxComplete', function() {
        self.checkCart();
      });
    });
    this.checkCart();
  }
}
setupFee.init();